import styled from "styled-components";
import { WrapContainer } from "../../components/wrapContainer";
import { useDescriptiveBlockQuery } from "../../generated/graphql";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { useForm, SubmitHandler, FormProvider } from "react-hook-form";
import { RoundedButton } from "../../components/roundedButton";
import { InputGroup, Inputs, SelectGroup } from "./inputs";
import { useAddLeadMutation, LeadInput } from "../../generated/graphql";
import { Provinces } from "./provinces";
import { useEffect, useState } from "react";
import { Spinner } from "@fluentui/react-components";

const formatter = new Intl.DateTimeFormat("fr-CA", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const Container = styled.form`
  max-width: var(--page-max-width);
  width: 100%;
  padding-bottom: 2em;
  p {
    max-width: 70ch;
  }
  h1 {
    line-height: 1;
  }

  textArea {
    width: 100%;
    max-width: 70ch;
    height: 200px;
    font-family: inherit;
    padding: 0.5em;
    box-sizing: border-box;
  }
`;

const Label = styled.div`
  font-weight: bold;
`;
const InputsGrid = styled.div`
  display: grid;
  grid-row-gap: 2em;
  grid-column-gap: 2em;
  padding-bottom: 2em;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`;
const SubmitDiv = styled.div`
  flex-direction: row;
  display: flex;
  gap: 1em;
  align-items: center;
  justify-content: space-between;
`;
export function PreventivoForm() {
  const methods = useForm<Inputs>({
    defaultValues: { tipo_persona: { label: "Azienda", value: "azienda" } },
  });
  const { register, handleSubmit, watch, reset } = methods;

  const [status, setStatus] = useState<"waiting" | "loading" | "finished">(
    "waiting",
  );

  useEffect(() => {
    if (status === "finished") {
      window.alert(
        "la ringraziamo per la sua richiesta verrà contattato entro 24/48 ore lavorative",
      );
    }
  }, [status]);

  const [{ data }] = useDescriptiveBlockQuery({
    variables: { id: "MUFYsedXzs5ahsE2Ucy4T" },
  });
  const [_mutResponse, addLead] = useAddLeadMutation();
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    setStatus("loading");
    const formattedDate = formatter.format(new Date());
    const lead: LeadInput = {
      tipo_persona: data.tipo_persona.value,
      nome: data.nome,
      cognome: data.cognome,
      email: data.email,
      cellulare: data.cellulare,
      provincia: data.provincia.value,
      regione: data.provincia.regione,
      cf: data.cf,
      piva: data.piva,
      nomecliente: data.nomecliente,
      pot: "1",
      datacontatto: formattedDate,
      note: data.note,
    };

    const response = await addLead({ arg1: lead });
    console.log(response);
    if (!response.error) {
      setStatus("finished");
      reset();
    }
  };

  const tipo_persona = watch("tipo_persona");
  useEffect(() => {
    if (tipo_persona.label === "Azienda") {
      methods.setValue("nome", "");
      methods.setValue("cognome", "");
      methods.setValue("cf", "");
    } else {
      methods.setValue("nomecliente", "");
      methods.setValue("piva", "");
    }
  }, [methods, tipo_persona]);
  return (
    <WrapContainer grey>
      <FormProvider {...methods}>
        <Container onSubmit={handleSubmit(onSubmit)}>
          <h1>{data?.descriptiveBlock?.title}</h1>

          {documentToReactComponents(data?.descriptiveBlock?.description?.json)}
          <InputsGrid>
            <SelectGroup
              label="Che tipo di cliente sei?"
              name="tipo_persona"
              options={[
                { label: "Azienda", value: "azienda" },
                {
                  label: "Libero Professionista",
                  value: "libero professionista",
                },
                { label: "Privato", value: "privato" },
              ]}
            />
          </InputsGrid>

          <InputsGrid>
            <SelectGroup
              label="Provincia in cui ti trovi"
              name="provincia"
              options={Provinces}
            />

            {(watch("tipo_persona").label === "Azienda" ||
              watch("tipo_persona").label === "Libero Professionista") && (
              <>
                <InputGroup name="nomecliente" label="Nome Azienda" />
                <InputGroup name="piva" label="Partita Iva" />
              </>
            )}

            {watch("tipo_persona").label === "Privato" && (
              <>
                <InputGroup name="nome" label="Nome" />
                <InputGroup name="cognome" label="Cognome" />
                <InputGroup name="cf" label="Codice Fiscale" />
              </>
            )}

            <InputGroup name="email" label="Email" type="email"></InputGroup>
            <InputGroup
              name="cellulare"
              label="Numero di telefono"
              type="tel"
            />
          </InputsGrid>
          <InputsGrid>
            <div>
              <Label>Note e richieste:</Label>
              <textarea {...register("note")} />
            </div>
          </InputsGrid>

          {status === "finished" && (
            <>Grazie! Ti ricontatteremo al più presto</>
          )}
          {status === "waiting" && (
            <SubmitDiv>
              Premendo il tasto "Invia" dichiari di aver letto e compreso
              l’Informativa Privacy e acconsento al trattamento dei miei dati
              personali ai sensi del Regolamento UE 2016/679.
              <RoundedButton className="solid" type="submit">
                Invia
              </RoundedButton>
            </SubmitDiv>
          )}
          {status === "loading" && <Spinner style={{ width: 50 }} />}
        </Container>
      </FormProvider>
    </WrapContainer>
  );
}
